// extracted by mini-css-extract-plugin
export default {"item_title":"Stock_item_title__A2Ti4","text":"Stock_text__pxH2O","item":"Stock_item__u98FD"};